(function($) {

  $('.menu-toggle').on('click touchstart', function(e) {
    $('body').toggleClass('menu-open');
    $('.hamburger-button').toggleClass('is-active');
    e.preventDefault();
  });

})(jQuery);